import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { checkIsBusinessUser } from "selectors/user";
import { checkSelectedBusinessRpaMode, getCurrentZohoOrganizationId, getSelectedBusinessData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import AuditSubsectionRoutes from "const/AuditSubsectionRoutes";
import ConfidenceAppend from "nlib/common/ConfidenceAppend";
import React from "react";
import SelectContactInput from "nlib/common/SelectContactInput";
import TransactionTypes from "const/TransactionTypes";
import Transactions from "utils/Transactions";
import classNames from "classnames";

const SelectContact = (props) => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const {
    auditRoute,
    className,
    vendorId,
    address,
    currency,
    disabled,
    documentId,
    placeholder = disabled ? uiTexts.noContact : undefined,
    transaction,
    transactionState,
    onChange
  } = props;

  const {
    settings: { advancedDocumentsWorkflow, allowApproveWithoutPayee } = {}
  } = useSelector(getSelectedBusinessData);

  const { usesItems, type } = transaction;

  const withdrawTransaction = type === TransactionTypes.WITHDRAW;

  const businessUser = useSelector(checkIsBusinessUser);

  const rpaMode = useSelector(checkSelectedBusinessRpaMode);

  const zohoBusiness = !!useSelector(getCurrentZohoOrganizationId);

  const nameNotChanged = address?.name === (transaction?.address?.name || "");

  const categorizeByReason = rpaMode && transactionState.reason?.trim() && !transactionState.manualMode;

  const invalidContactChange = !businessUser && !categorizeByReason
    && !Transactions.validateContactChange(transactionState, transaction);

  const needDocument = address?.needDocument;

  return (
    <div className={classNames(Css.contact, !disabled && needDocument && Css.needDocument, className)}>
      <ConfidenceAppend
        className={Css.confidenceAppend}
        confidence={address?.confidence}>
        <SelectContactInput
          useWidget
          value={address}
          disabled={disabled}
          currency={currency}
          placeholder={placeholder}
          onlyVendors={withdrawTransaction && zohoBusiness}
          onlyCustomers={!!usesItems || (!withdrawTransaction && zohoBusiness)}
          probablyVendor={withdrawTransaction && !usesItems}
          active={(!auditRoute || !nameNotChanged) && !!(address?.name && !vendorId)}
          invalid={invalidContactChange || (auditRoute
            ? ((!nameNotChanged || (auditRoute === AuditSubsectionRoutes.NO_PAYEE)) && !vendorId)
            : (!vendorId && (!documentId || !advancedDocumentsWorkflow) && !allowApproveWithoutPayee))}
          valid={!!(address?.name && (vendorId || (auditRoute && nameNotChanged)))}
          onChange={onChange} />
      </ConfidenceAppend>
      {!businessUser && !address?.confidence && !disabled && needDocument && (
        <div className={Css.warningIcon} data-tooltip={messages.vendorNeedDocumentWarning}>
          <Icons.Warning />
        </div>
      )}
    </div>
  );
};

export default React.memo(SelectContact);
